'use strict';

var JqxGridSelectionDirective = function JqxGridSelectionDirective() {
  return {
    controller: 'JqxGridSelectionController',
    scope: true
  };
};
JqxGridSelectionDirective.$inject = [];
module.exports = JqxGridSelectionDirective;